import axios from 'axios';

export const MessageOfTheDayGet = async () => {
  try {
    const result = await axios({
      method: 'get',
      url: '/v1/MessageOfTheDay',
      params: {},
    });

    return result.data;
  } catch (err) {
    console.error(err);
  }
};

export const MessageOfTheDaySet = async (message) => {
  try {
    const result = await axios({
      method: 'post',
      url: 'v1/MessageOfTheDay',
      data: { message },
    });

    return result.data;
  } catch (err) {
    console.error(err);
  }
};
